
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { isWebAuthnAvailable } from '~/plugins/webauthn'

export default Vue.extend({
  name: 'NotificationBell',
  data() {
    return {
      webAuthnSupported: false,
      hasPasskey: false,
      passkeyCheckDone: false
    }
  },
  computed: {
    ...mapGetters({
      getSuggestedNotifications: 'notifications/getSuggestedNotifications',
      userRedeem: 'notifications/getUserRedeem',
      incompleteApplicationsCount: 'notifications/getCountApplicationsIncomplete',
      applicationsLoaded: 'notifications/getApplicationsLoaded',
      personalityTestNotification: 'notifications/getPersonalityTestNotification'
    }),
    phoneVerified(): boolean {
      return this.$auth?.user?.phone_verified || false
    },
    passkeyPromptDismissed(): boolean {
      return !!(this.$auth?.user?.passkey_prompt_dismissed || this.$auth?.user?.passkey_prompt_dismissed_at)
    },
    showPasskeyNotification(): boolean {
      return this.webAuthnSupported &&
             !this.passkeyPromptDismissed &&
             !this.hasPasskey &&
             this.passkeyCheckDone
    },
    notificationCount(): number {
      let count = 0
      if (!this.phoneVerified) {
        count++
      }
      if (this.showPasskeyNotification) {
        count++
      }
      if (this.incompleteApplicationsCount > 0) {
        count += this.incompleteApplicationsCount
      }
      if (this.personalityTestNotification || !this.hasCompletedPersonalityTest) {
        count++
      }
      if (this.getSuggestedNotifications) {
        count += this.getSuggestedNotifications
      }
      if (this.userRedeem > 50) {
        count++
      }
      return count
    },
    hasCompletedPersonalityTest() {
      return this.$auth?.user?.mbti && this.$auth.user.mbti !== ''
    }
  },
  watch: {
    '$auth.loggedIn': {
      immediate: true,
      handler(loggedIn: boolean) {
        if (loggedIn) {
          this.checkPasskeyStatus()
          this.checkIncompleteApplications()
        }
      }
    }
  },
  mounted() {
    if (process.client) {
      this.webAuthnSupported = isWebAuthnAvailable()
      if (this.$auth?.loggedIn) {
        this.checkPasskeyStatus()
        this.checkIncompleteApplications()
      }
    }
  },
  methods: {
    async checkPasskeyStatus() {
      if (!this.webAuthnSupported || !this.$webauthn) {
        this.passkeyCheckDone = true
        return
      }
      try {
        this.hasPasskey = await this.$webauthn.hasPasskeyRegistered()
      } catch {
        this.hasPasskey = false
      }
      this.passkeyCheckDone = true
    },
    async checkIncompleteApplications() {
      await this.$store.dispatch('notifications/fetchIncompleteApplications', this.$axios)
    },
    goToNotifications() {
      let width = 768
      let path = ''
      if (process.browser) {
        width = window.innerWidth
      }
      if (width < 768) {
        path = 'user-settings'
      } else {
        path = 'user-settings-profile'
      }
      this.$router.push(this.localePath({ name: path }))
    }
  }
})
